export const ASSIGNED = "Assigned";
export const ACCEPTED = "Accepted";
export const PARTIALLY_ACCEPTED = "Partially Accepted";
export const REJECTED = "Rejected";
export const REJECTION_ACCEPTED = "Rejection Accepted";
export const REASSIGNED = "Reassigned";
export const RELEASED = "Released";
export const RELEASE_APPROVED = "Release Approved";
export const RELEASE_REJECTED = "Release Rejected";
export const AREA_RELEASED = "Area Released";
export const OVERDUE = "Overdue";
